// extracted by mini-css-extract-plugin
module.exports = {"Container":"mobile-dropdown-module--Container--VB_Vo"};